import dispatcher from "../dispatcher"
import { EFirestoreAsyncActionType, IPayrollPayGroupData } from "../models"
import * as api from "../api"
import * as utils from "../helpers/utils"
import AppStateStore from "../stores/AppStateStore"
import strings from "../localization/strings"
import AccountStore from "../stores/AccountStore"
import * as firebaseActions from "./FirebaseActions"

export function getPayrollTimeData(accountId, levelIdFilter, payGroupIds: string[], referenceDate, payrollByJob) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.GetPayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncGetPayrollTimeData(accountId, levelIdFilter, payGroupIds, referenceDate, asyncSessionId, payrollByJob)
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_get_payroll_Please_try_again_later)
            }) :
        api.getPayrollTimeData(accountId, levelIdFilter, payGroupIds, referenceDate, asyncSessionId, payrollByJob)
            .then(res =>
                firebaseActions.handleAction(res.data, asyncSessionId)
            )
}

export function lockPayrollTimeHierarchy(accountId, payrollPayGroupDataList: IPayrollPayGroupData[], payGroupIds: string[], individualLockEmployeeIds: string[], startDate, endDate, levelIdFilter, successAsyncCb = null) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.LockPayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncLockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, individualLockEmployeeIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(() => successAsyncCb && successAsyncCb())
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_lock_payroll_Please_try_again_later)
            }) :
        api.lockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, individualLockEmployeeIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(
                    res.data,
                    asyncSessionId,
                    () => lockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, individualLockEmployeeIds, startDate, endDate, levelIdFilter, successAsyncCb),
                    successAsyncCb,
                    null,
                    individualLockEmployeeIds.length > 0
                )
            )

}

export function employeeLockPayrollTimeHierarchy(accountId, payrollPayGroupDataList: IPayrollPayGroupData[], payGroupIds: string[], startDate, endDate, levelIdFilter, successAsyncCb = null) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.EmployeeLockPayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncEmployeeLockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(() => successAsyncCb && successAsyncCb())
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_employee_lock_payroll_Please_try_again_later)
            }) :
        api.employeeLockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(
                    res.data,
                    asyncSessionId,
                    () => lockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, null, startDate, endDate, levelIdFilter, successAsyncCb),
                    successAsyncCb
                )
            )

}

export function unlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList: IPayrollPayGroupData[], payGroupIds: string[], individualLockEmployeeIds: string[], startDate, endDate, levelIdFilter, successAsyncCb = null) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.UnLockPayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncUnlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, individualLockEmployeeIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(() => successAsyncCb && successAsyncCb())
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_unlock_payroll_Please_try_again_later)
            }) :
        api.unlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, individualLockEmployeeIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(
                    res.data,
                    asyncSessionId,
                    () => unlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, individualLockEmployeeIds, startDate, endDate, levelIdFilter, successAsyncCb),
                    successAsyncCb
                )
            )
}

export function employeeUnlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList: IPayrollPayGroupData[], payGroupIds: string[], startDate, endDate, levelIdFilter, successAsyncCb = null) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.EmployeeUnLockPayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncEmployeeUnlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(() => successAsyncCb && successAsyncCb())
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_employee_unlock_payroll_Please_try_again_later)
            }) :
        api.employeeUnlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(
                    res.data,
                    asyncSessionId,
                    () => unlockPayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, null, startDate, endDate, levelIdFilter, successAsyncCb),
                    successAsyncCb
                )
            )
}

export function closePayrollTimeHierarchy(accountId, payrollPayGroupDataList: IPayrollPayGroupData[], payGroupIds: string[], startDate, endDate, levelIdFilter, successAsyncCb = null) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.ClosePayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncClosePayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(() => successAsyncCb && successAsyncCb())
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_close_payroll_Please_try_again_later)
            }) :
        api.closePayrollTimeHierarchy(accountId, payrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(res.data, asyncSessionId, null, successAsyncCb)
            )
            .catch(err => AppStateStore.setProgressSnackbarContent(err.response.data.message))
}

export function lockClosePayrollTimeHierarchy(accountId, lockPayrollPayGroupDataList: IPayrollPayGroupData[], closePayrollPayGroupDataList: IPayrollPayGroupData[], payGroupIds: string[], startDate, endDate, levelIdFilter, successAsyncCb = null) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.ClosePayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncLockClosePayrollTimeHierarchy(accountId, lockPayrollPayGroupDataList, closePayrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(() => successAsyncCb && successAsyncCb())
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_close_payroll_Please_try_again_later)
            }) :
        api.lockClosePayrollTimeHierarchy(accountId, lockPayrollPayGroupDataList, closePayrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(
                    res.data,
                    asyncSessionId,
                    () => lockClosePayrollTimeHierarchy(accountId, lockPayrollPayGroupDataList, closePayrollPayGroupDataList, payGroupIds, startDate, endDate, levelIdFilter, successAsyncCb),
                    successAsyncCb
                )
            )
            .catch(err => AppStateStore.setProgressSnackbarContent(err.response.data.message))
}

export function exportEmployeePayrollTime(accountId, employeeIds, payGroupIds: string[], startDate, endDate, levelIdFilter) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.ExportPayrollTime
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.asyncExportEmployeePayrollTime(accountId, employeeIds, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_export_payroll_Please_try_again_later)
            }) :
        api.exportEmployeePayrollTime(accountId, employeeIds, payGroupIds, startDate, endDate, levelIdFilter, asyncSessionId)
            .then(res => {
                if (res.data) {
                    firebaseActions.handleAction(res.data, asyncSessionId)
                }
                else {
                    //export by api case
                    AppStateStore.setProgressSnackbarContent(null)
                }
            })
            .catch(err => {
                const errMsg = err.response.data.message as string
                if (errMsg.includes("Export Payroll is running now")) {
                    AppStateStore.setAlertDialogContent({ content: errMsg })
                }
                if (errMsg.includes("Export Payroll is requested already")) {
                    AppStateStore.setConfirmDialogContent({
                        content: strings.Export_Payroll_is_requested_already_Are_you_sure_you_want_to_ignore_previous_request_and_export,
                        confirmBtnLabel: strings.Proceed,
                        confirm: async () => {
                            let error = false
                            try {
                                await api.deletePayrollExportScheduleJobRequest(accountId)
                            }
                            catch (e) {
                                error = true
                                e.response.data.message &&
                                    AppStateStore.setAlertDialogContent({ content: e.response.data.message })
                            }
                            if (!error) {
                                exportEmployeePayrollTime(accountId, employeeIds, payGroupIds, startDate, endDate, levelIdFilter)
                            }
                        }
                    })
                }
            })
}

export async function downloadPayrollTimeReportFile(accountId, levelIdFilter, payGroupIds: string[], referenceDate) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.DownloadPayrollTimeReport
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.getAsyncPayrollTimeReportDataDownload(accountId, levelIdFilter, payGroupIds, referenceDate, asyncSessionId)
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_download_payroll_report_Please_try_again_later)
            }) :
        api.getPayrollTimeReportDataDownload(accountId, levelIdFilter, payGroupIds, referenceDate, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(res.data, asyncSessionId)
            )
}

export async function downloadPayrollTimeFile(accountId, levelIdFilter, payGroupIds: string[], referenceDate) {
    const asyncSessionId = utils.guid()
    dispatcher.dispatch({
        type: "UPDATE_ASYNC_SESSION",
        data: {
            asyncSessionId,
            asyncActionType: EFirestoreAsyncActionType.DownloadPayrollTimeFile
        }
    })

    AccountStore.getPayrollLambdaEnabled() ?
        api.getAsyncPayrollTimeDataDownload(accountId, levelIdFilter, payGroupIds, referenceDate, asyncSessionId)
            .catch(err => {
                console.log(err)
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_download_payroll_Please_try_again_later)
            }) :
        api.getPayrollTimeDataDownload(accountId, levelIdFilter, payGroupIds, referenceDate, asyncSessionId)
            .then(res =>
                firebaseActions.handleAction(res.data, asyncSessionId)
            )
}

export function downloadPayrollExpensesReportFile(accountId, levelIdFilter, payGroupIds: string[], referenceDate) {
    api.getPayrollExpensesReportDataDownload(accountId, levelIdFilter, payGroupIds, referenceDate).then(res => {
        window.location = res.data
    })
}

export function downloadPayrollExpensesFile(accountId, levelIdFilter, payGroupIds: string[], referenceDate, priorPeriod: boolean) {
    api.getPayrollExpensesDataDownload(accountId, levelIdFilter, payGroupIds, referenceDate, priorPeriod).then(res => {
        window.location = res.data
    })
}

export function exportEmployeePayrollExpenses(accountId, employeeIds, payGroupIds: string[], startDate, endDate, levelIdFilter) {
    return api.exportEmployeePayrollExpenses(accountId, employeeIds, payGroupIds, startDate, endDate, levelIdFilter)
}

export function expensePayrollFileDownload(accountId: string, expenseId: string) {
    return api.expensePayrollFileDownload(accountId, expenseId)
}

export function exportEmployeePayrollPriorPeriodExpenses(accountId, employeeIds, payGroupIds: string[], startDate, endDate, levelIdFilter) {
    return api.exportEmployeePayrollPriorPeriodExpenses(accountId, employeeIds, payGroupIds, startDate, endDate, levelIdFilter)
}

export function recalcFailedAccrual(payrollStatusDocIds: string[]) {
    AppStateStore.setProgressSnackbarContent("loading")
    api.recalcFailedAccrual(payrollStatusDocIds)
        .then(() => {
            AppStateStore.setProgressSnackbarContent(null)
            AppStateStore.setGetPayrollTimeByAction()
        })
        .catch(err => AppStateStore.setProgressSnackbarContent(err.response.data.message))
}

export function closeExportPayrollTimeResultDialog() {
    dispatcher.dispatch({ type: "SHOW_EXPORT_PAYROLL_TIME_RESULT", data: [] })
}
